import { createContext, Dispatch, ReactNode, SetStateAction, useContext, useState } from "react";
import { Item } from "../../../../../utils/types/generals";
import { formatFilter, formData, useFilterInputs } from "../pages/main/initialState";
import { FilterBody, FilterProps } from "../../../../../hooks/filter/typing";
import { removeAllReference } from "../../../../../utils/methods/removedReference";
import { useFilter } from "../../../../../hooks/filter";
import { useDownload } from "../../../../../hooks/download/useDownload";
import { returnQueryWithPagination } from "../../../../../utils/methods/returnQuery";
import { reportFolioServices } from "../../../../../utils/constants/callService";
import { useTranslation } from "react-i18next";
import { InputModel } from "../../../../../utils/types";

export const ReportFolioConfigContext = createContext<{
    setItems: Dispatch<SetStateAction<{
        areas: Item[];
        departments: Item[];
    }>>
    input: Record<string, InputModel>
    setInput: Dispatch<SetStateAction<Record<string, InputModel>>>
    totalPages: number
    setTotalPages: Dispatch<SetStateAction<number>>
    generalFilter: FilterBody
    downloadConfig: {
        download: {
            excel: boolean;
            pdf: boolean;
            word: boolean;
        };
        openSnackbar: {
            open: boolean;
            message: string;
            type: string;
        };
        downloadCSV: () => void;
        downloadPDF: () => void;
        downloadWORD: () => void;
        closeOpenSnakbar: () => void;
        downloadCustome: (type?: "excel" | "pdf" | "word") => void;
    }
    items: {
        areas: Item[];
        departments: Item[];
    }
}>(Object({}))

export const useReportFolioConfigContext = () => useContext(ReportFolioConfigContext)

export const ReportFolioConfigProvider = ({ children }: { children: ReactNode }) => {
    const { t } = useTranslation()
    const [items, setItems] = useState<{
        areas: Item[];
        departments: Item[];
    }>({ areas: [], departments: [] })
    const [totalPages, setTotalPages] = useState(0)
    const { input, setInput } = useFilterInputs({ items })
    const externalValidation: FilterProps['externalValidation'] = ({ name, body, setFilterData }) => {
        let localeBody: Record<string, any> = removeAllReference(body)

        if (name === 'area') {
            const { area, department } = localeBody
            const departmentFiltereds = department?.filter((department: any) => area.find((area: any) => area.value == department.areaId))
            let departmentItems: any[] = []

            area?.forEach((area: any) => {
                const id = area.value
                const childs = items.departments.filter((department) => department.areaId == id)
                departmentItems.push(...childs)
            })

            setInput(prev => ({ ...prev, department: { ...prev.department, items: departmentItems } }))
            setFilterData((prev) => ({
                ...prev,
                department: departmentFiltereds,
            }))

            localeBody = {
                ...localeBody,
                department: departmentFiltereds,
            }
        }

        return localeBody
    }
    const generalFilter = useFilter({ formatFilter: formatFilter, externalValidation })
    const downloadConfig = useDownload({
        docName: t('reportFolio.dashboard.header.title'),
        query: returnQueryWithPagination({ filter: generalFilter.filterString, sort: generalFilter.query.sort }, formData),
        downloadFuntion: reportFolioServices.downloadConfigFolio,
    })
    return (
        <ReportFolioConfigContext.Provider
            value={{
                setItems,
                generalFilter,
                items,
                input,
                setInput,
                downloadConfig,
                setTotalPages,
                totalPages,
            }}
        >
            {children}
        </ReportFolioConfigContext.Provider>
    )
}